import { useState, useCallback } from 'react'

import { message as $message } from 'antd'
import { getWechatCode } from '@/services/distributeOrder'

interface useWechatCodeReturn {
    imgUrl: string
    // 引导关注公众号的二维码
    getUrl: () => void
    // 获取引导公众号二维码
}

export default (): useWechatCodeReturn => {
    const [imgUrl, setImgUrl] = useState('')

    const getUrl = useCallback(async () => {
        const { data, message, success } = await getWechatCode()
        if (success) {
            setImgUrl(data)
        } else {
            $message.error(message)
        }
    }, [])
    


    return { imgUrl, getUrl }
}
